"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var A = _styledComponents.default.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: black;\n  font-family: 'Gentleman', Arial, sans-serif;\n  ", "\n"])), function (_ref) {
  var $bsStyle = _ref.$bsStyle;
  return $bsStyle || '';
});
exports.A = A;